import React from 'react';
import styled from 'styled-components';
import { secondaryFont, wLight, primaryHeadingColor } from 'Utils/utilsStyle';

type Props = {
  personalityType?: string,
  personalityColor?: string,
} & typeof defaultProps;

const defaultProps = {
  personalityType: 'Driver',
  personalityColor: '#FF0019',
};

const Wrapper = styled.h1<{ color: string }>`
  font-size: 34px;
  line-height:34px;
  color:${primaryHeadingColor};
  font-weight:${wLight};
  font-family: ${secondaryFont};
  margin-bottom:30px;
  text-align:left;
  span{
    color: ${(props) => props.color};
  }
`;

const PersonalityTitle = function PersonalityTitle(props: Props) {
  const {
    personalityType,
    personalityColor,
  } = props;
  return (
    <Wrapper color={personalityColor}>
      <h1 className="personality-title">
        The
        {' '}
        <span>{personalityType}</span>
        {' '}
        Personality
      </h1>
    </Wrapper>
  );
};

PersonalityTitle.defaultProps = defaultProps;
export default PersonalityTitle;
